import intersection from 'lodash/intersection'
import difference from 'lodash/difference'
import type { BaseFilterValue } from '@/components/FiltersDrawer/types'

/**
 * This function creates available filters for a set of facets.
 * It takes into account the order of facets specified by the `facetOrdering` parameter.
 * The function reduces the facets to a single object, mapping each facet to a list of its possible values.
 *
 * @param {Object} facets - An object mapping each facet to an object of its possible values.
 * @param {any} facetOrdering - An object specifying the order of values for each facet.
 * @returns {Object} - An object mapping each facet to a list of its possible values.
 */
export const createAvailableFilters = (
  facets: Record<string, Record<string, number>> | undefined,
  facetOrdering: any,
) =>
  Object.entries(facets ?? {}).reduce(
    (accum, [key, value]) => {
      const facetOrder = facetOrdering?.values?.[key]?.order ?? []

      const values = [
        ...intersection(facetOrder, Object.keys(value)),
        ...difference(Object.keys(value), facetOrder),
      ]

      accum[key] = values.map((key) => ({
        label: key,
        value: key,
      }))
      return accum
    },
    {} as { [key: string]: BaseFilterValue[] },
  )
